import { get, isNil } from 'lodash'
import CapitalizeValueDisplay from '../../common/CapitalizeValueDisplay'

const MatchingDataFieldDisplay = (record, column) => {
  const fieldValue = get(get(record, 'matching_data', {}), column.key)
  if (isNil(fieldValue)) {
    return ''
  }

  return CapitalizeValueDisplay(fieldValue)
}

export default MatchingDataFieldDisplay
